<wuc-button type="clean" modal-close-btn title="Sluit">
  <wuc-icon-ui icon="cross-closed"></wuc-icon-ui>
</wuc-button>
<div class="h3" modal-title i18n="@@authentication.logout.title">
  Are you sure you want to log out?
</div>
<div modal-content>
  <p i18n="@@authentication.logout.sub-title">
    The benefits of staying logged in:
  </p>
  <wuc-list icon="check">
    <wuc-list-item *ngFor="let advantage of advantages"
      >{{ advantage }}</wuc-list-item
    >
  </wuc-list>
</div>
<div modal-actions alignment="between">
  <wuc-link type="secondary" (clicked)="cancel()">Nee, toch niet </wuc-link>
  <wuc-button type="primary" (buttonClick)="logout()"
    >{{ genericButtonTexts.logout }}
  </wuc-button>
</div>
